import { Pagination } from '@shared/model/common';

export const paginationData = ({ skip, take, total }: Pagination) => {
    const validSkip = skip || 0;
    // В случае, когда take === null, возвращаются все элементы
    const validTake = take || Number.MAX_VALUE;

    // Должна быть минумум одна страница
    const maxPage = Math.ceil(Math.max(1, total / validTake));
    const skippedPage = Math.ceil(validSkip / validTake);
    const currentPage = skippedPage + 1 >= maxPage ? maxPage : skippedPage + 1;

    return {
        maxPage,
        currentPage,
        validTake,
    };
};
